import { useState } from 'react';
import { Footer } from '../../components/Footer/Footer';
import { RegistrationForm } from '../../components/RegistrationForm/RegistrationForm';
import { Success } from '../../components/Success/Success';
import { VerifyUserForm } from '../../components/VerifyUserForm/VerifyUserForm';
import { APP_PATHS } from '../../constants/paths';
import { Copy } from '../../copy/Copy';
import { PageContainer } from '../../containers/PageContainer/PageContainer';

export const Register = () => {
  const [isRegistered, setIsRegistered] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [userEmail, setUserEmail] = useState();

  const handleRegister = (email) => {
    setIsRegistered(true);
    setUserEmail(email);
  };

  const handleVerify = () => {
    setIsVerified(true);
  };

  return (
    <PageContainer>
      {!isRegistered && !isVerified && (
        <RegistrationForm handleRegister={handleRegister} />
      )}

      {isRegistered && !isVerified && (
        <VerifyUserForm userEmail={userEmail} handleVerify={handleVerify} />
      )}

      {isRegistered && isVerified && (
        <Success
          title={Copy.generate('Register.title')}
          to={APP_PATHS.login}
          textIdentifier="Links.verified"
          linkText={Copy.generate('Global.login')}
        />
      )}

      <Footer />
    </PageContainer>
  );
};
